import React, { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";

import BreakdownChartCard from "../../../../../components/Dashboard/BreakdownChartCard";
import DashboardSummaryStrip from "../../../../../components/Dashboard/DashboardSummaryStrip";
import TimeSeriesCard from "../../../../../components/Dashboard/TimeSeriesCard";
import { formatMoney, formatNumber } from "../../../../../libs/dashboardOverview";

const OverviewSection = ({ overview }) => {
  const [timeframe, setTimeframe] = useState(6);

  return (
    <Stack spacing={2}>
      <Stack spacing={0.5}>
        <Typography variant="h5" sx={{ fontWeight: 800 }}>
          Overview
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Platform operations, people review, and finance health.
        </Typography>
      </Stack>
      <DashboardSummaryStrip items={overview?.summary || []} />
      <TimeSeriesCard
        title="Platform invoice volume"
        subtitle="Contractor invoice amount by month"
        data={overview?.seriesByRange?.[timeframe] || overview?.series || []}
        formatter={formatMoney}
        timeframe={timeframe}
        onTimeframeChange={setTimeframe}
      />
      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", md: "repeat(3, minmax(0, 1fr))" } }}>
        <Box>
          <BreakdownChartCard title="Operations pipeline" subtitle="Hire requests and pricing queue" data={overview?.breakdowns?.operations || []} formatter={formatNumber} color="#1a73e8" />
        </Box>
        <Box>
          <BreakdownChartCard title="People workflow" subtitle="Contractor review and timesheet state" data={overview?.breakdowns?.people || []} formatter={formatNumber} color="#05690D" />
        </Box>
        <Box>
          <BreakdownChartCard title="Finance status" subtitle="Invoice amount by state" data={overview?.breakdowns?.finance || []} formatter={formatMoney} color="#f9ab00" />
        </Box>
      </Box>
    </Stack>
  );
};

export default OverviewSection;
